// convert date 2024-05-13 to Mon, 13. May, 2024
export const convertDate = (date: string): string => {
    // Create an array of month names
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Create an array of day names
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    // Split the input date string into components
    const [year, month, day] = date.split("-").map(Number);

    // Create a new Date object
    const dateObj = new Date(year, month - 1, day);

    // Get the day of the week, month name, and formatted date string
    const dayName = days[dateObj.getDay()];
    const monthName = months[month - 1];
    const formattedDate = `${dayName}, ${day}. ${monthName}, ${year}`;

    return formattedDate;
};